import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field required" }
const _hoisted_2 = { class: "p-error" }
const _hoisted_3 = { class: "formgrid flex" }
const _hoisted_4 = { class: "field col required p-0 pr-2 flex flex-column" }
const _hoisted_5 = { class: "p-error" }
const _hoisted_6 = { class: "field col required p-0 pl-2 flex flex-column" }
const _hoisted_7 = { class: "p-error" }
const _hoisted_8 = { class: "field required" }
const _hoisted_9 = { class: "p-error" }
const _hoisted_10 = {
  key: 0,
  class: "formgrid flex"
}
const _hoisted_11 = { class: "field col required p-0 pr-2" }
const _hoisted_12 = { class: "p-error" }
const _hoisted_13 = { class: "field col required p-0 pl-2" }
const _hoisted_14 = { class: "p-error" }
const _hoisted_15 = { class: "field required flex flex-column" }
const _hoisted_16 = { class: "p-error" }
const _hoisted_17 = { class: "field flex flex-column" }
const _hoisted_18 = { class: "field required" }
const _hoisted_19 = { class: "p-error" }
const _hoisted_20 = { class: "field required" }
const _hoisted_21 = { class: "p-error" }

import { Ref, ref, reactive, onMounted, computed } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required, requiredIf, minValue, helpers } from '@vuelidate/validators';
import { useDisciplineStore, PersonStores, useServicesStore } from '@/store';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import InputSwitch from 'primevue/inputswitch';
import InputNumber from 'primevue/inputnumber';

import { FREQUENCY_INTERVALS_OPTIONS, FREQUENCY_AMOUNT } from '@/enum';
import {
  UserTreatmentPlansStateInterface,
  TreatmentPlanTypeGenericInterface,
  TreatmentPlanServiceCreationInterface,
} from '@/types';
import { ServiceInterface } from '@/types/Service';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddService',
  emits: ["save", "cancel"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const newService = reactive<TreatmentPlanServiceCreationInterface>({
  treatment_service_type_id: 0,
  discipline_id: 0,
  start_at: undefined,
  end_at: undefined,
  duration: 30,
  treatment_frequency_type: { id: 0, acronym: '' },
  frequency: undefined,
  interval: undefined,
  service_id: 0,
  is_group: false,
});

const disciplineStore = useDisciplineStore();
const treatmentPlansStore = PersonStores.useUserTreatmentPlansStore();
const connectionStore = PersonStores.useUserConnectionsStore();
const servicesStore = useServicesStore();
const disciplines: Ref<{ id: number; name: string }[]> = ref([]);
const frequencyTypes: Ref<UserTreatmentPlansStateInterface[]> = ref([]);
const serviceTypes: Ref<TreatmentPlanTypeGenericInterface[]> = ref([]);
const services: Ref<ServiceInterface[]> = ref([]);
const modalVisible = ref(true);
const customFrequencySelected = computed(() => newService.treatment_frequency_type?.acronym === 'CUSTOM');
const frequencyIntervals = FREQUENCY_INTERVALS_OPTIONS;
const frequencyAmount = FREQUENCY_AMOUNT;

const frequencyTypeRequired = (value: TreatmentPlanServiceCreationInterface['treatment_frequency_type']) => !!value?.id;

const rules = computed(() => {
  return {
    treatment_service_type_id: {
      required: helpers.withMessage('Please select Service Type', minValue(1)),
    },
    discipline_id: {
      minValue: helpers.withMessage('Please select Discipline', minValue(1)),
    },
    start_at: {
      required: helpers.withMessage('Please choose Start Date', required),
    },
    end_at: {
      required: helpers.withMessage('Please choose End Date', required),
      minValue: helpers.withMessage(
        'Please choose a date greater than or equal to Start Date',
        minValue(newService.start_at as string),
      ),
    },
    treatment_frequency_type: {
      required: helpers.withMessage('Please select Frequency', frequencyTypeRequired),
    },
    duration: { required: helpers.withMessage('Please choose Duration', required) },
    frequency: {
      requiredIfCustom: helpers.withMessage('Please select Frequency', requiredIf(customFrequencySelected.value)),
    },
    interval: {
      requiredIfCustom: helpers.withMessage('Please select Interval', requiredIf(customFrequencySelected.value)),
    },
    service_id: {
      required: helpers.withMessage('Please select Service', minValue(1)),
    },
  };
});

const v$ = useVuelidate(rules, newService, { $autoDirty: true });

onMounted(async () => {
  await connectionStore.getConnections();
  await fetchDataForForm();
});

const fetchDataForForm = async () => {
  let organizationId = null;
  if (connectionStore.$state.connections.organizations?.length) {
    organizationId = connectionStore.$state.connections.organizations[0].id;
  }
  disciplines.value = (await disciplineStore.getDisciplinesOfOrganizationForDropdown(organizationId as number)) as [];
  frequencyTypes.value = (await treatmentPlansStore.getTreatmentPlanFrequencyTypes()) as [];
  serviceTypes.value = await treatmentPlansStore.getTreatmentServiceTypes();
  await servicesStore.getOrganizationServices(organizationId as number);
  newService.treatment_service_type_id = serviceTypes.value.find((type) => type.acronym === 'REG')?.id as number;
  services.value = servicesStore.availableServices as [];
};

const saveAttempted = ref(false);

const save = () => {
  saveAttempted.value = true;
  v$.value.$touch();
  if (!v$.value.$invalid) {
    emit('save', newService);
  }
  return;
};

const cancel = () => {
  emit('cancel');
  modalVisible.value = false;
  return;
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((modalVisible).value = $event)),
    draggable: false,
    class: "dialog__container new-event-modal",
    modal: true,
    onHide: cancel
  }, {
    header: _withCtx(() => [...(_cache[11] || (_cache[11] = [
      _createElementVNode("h2", { textContent: 'Add New Service' }, null, -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: _normalizeClass(["p-4 pt-0 surface-100", { 'hide-input-errors': !saveAttempted.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { for: "discipline" }, "Discipline", -1)),
          _createVNode(_component_Dropdown, {
            id: "discipline",
            modelValue: newService.discipline_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newService.discipline_id) = $event)),
            class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).discipline_id.$invalid && _unref(v$).discipline_id.$dirty }]),
            required: "",
            options: disciplines.value,
            "option-value": "id",
            "option-label": "name",
            placeholder: "Select Discipline",
            onBlur: _unref(v$).discipline_id.$touch
          }, null, 8, ["modelValue", "options", "class", "onBlur"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).discipline_id.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "start_at" }, "Start Date", -1)),
            _createVNode(_unref(Calendar), {
              id: "start_at",
              modelValue: newService.start_at,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newService.start_at) = $event)),
              placeholder: "mm/dd/yyyy",
              autocomplete: "off",
              "max-date": newService.end_at,
              class: _normalizeClass({ 'p-invalid': _unref(v$).start_at.$invalid && _unref(v$).start_at.$dirty }),
              onBlur: _unref(v$).start_at.$touch
            }, null, 8, ["modelValue", "max-date", "class", "onBlur"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).treatment_frequency_type.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "input-errors"
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "end_at" }, "End Date", -1)),
            _createVNode(_unref(Calendar), {
              id: "end_at",
              modelValue: newService.end_at,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newService.end_at) = $event)),
              placeholder: "mm/dd/yyyy",
              "min-date": newService.start_at,
              class: _normalizeClass({ 'p-invalid': _unref(v$).end_at.$invalid && _unref(v$).end_at.$dirty }),
              onBlur: _unref(v$).end_at.$touch
            }, null, 8, ["modelValue", "min-date", "class", "onBlur"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).duration.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "input-errors"
              }, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "frequency" }, "Frequency", -1)),
          _createVNode(_component_Dropdown, {
            id: "frequency",
            modelValue: newService.treatment_frequency_type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newService.treatment_frequency_type) = $event)),
            class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).treatment_frequency_type.$invalid && _unref(v$).treatment_frequency_type.$dirty }]),
            required: "",
            options: frequencyTypes.value,
            "option-value": 
              (opt) => {
                return { id: opt.id, acronym: opt.acronym };
              }
            ,
            "option-label": "title",
            placeholder: "Select Frequency",
            onBlur: _unref(v$).treatment_frequency_type.$touch
          }, null, 8, ["modelValue", "options", "option-value", "class", "onBlur"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).treatment_frequency_type.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        (customFrequencySelected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "interval" }, "Interval", -1)),
                _createVNode(_component_Dropdown, {
                  id: "interval",
                  modelValue: newService.interval,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newService.interval) = $event)),
                  required: "",
                  options: _unref(frequencyIntervals),
                  "option-value": "value",
                  "option-label": "label",
                  placeholder: "Select Interval",
                  class: _normalizeClass({ 'p-invalid': _unref(v$).interval.$invalid && _unref(v$).interval.$dirty, 'w-full': true }),
                  onBlur: _unref(v$).interval.$touch
                }, null, 8, ["modelValue", "options", "class", "onBlur"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).interval.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "input-errors"
                  }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { for: "frequency_amount" }, "Frequency", -1)),
                _createVNode(_component_Dropdown, {
                  id: "frequency_amount",
                  modelValue: newService.frequency,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newService.frequency) = $event)),
                  required: "",
                  options: _unref(frequencyAmount),
                  "option-value": "value",
                  "option-label": "label",
                  placeholder: "Select Frequency",
                  class: _normalizeClass({ 'p-invalid': _unref(v$).frequency.$invalid && _unref(v$).frequency.$dirty, 'w-full': true }),
                  onBlur: _unref(v$).frequency.$touch
                }, null, 8, ["modelValue", "options", "class", "onBlur"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).frequency.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "input-errors"
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _cache[18] || (_cache[18] = _createElementVNode("label", { for: "duration" }, "Duration (Minutes)", -1)),
          _createVNode(_unref(InputNumber), {
            id: "duration",
            modelValue: newService.duration,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newService.duration) = $event)),
            min: 0,
            class: _normalizeClass({ 'p-invalid': _unref(v$).duration.$invalid && _unref(v$).duration.$dirty }),
            onBlur: _unref(v$).duration.$touch
          }, null, 8, ["modelValue", "class", "onBlur"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).duration.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { for: "can_group" }, "Can Group", -1)),
          _createVNode(_unref(InputSwitch), {
            id: "can_group",
            modelValue: newService.is_group,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newService.is_group) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[20] || (_cache[20] = _createElementVNode("label", { for: "service" }, "Service", -1)),
          _createVNode(_component_Dropdown, {
            id: "service",
            modelValue: newService.service_id,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newService.service_id) = $event)),
            class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).service_id.$invalid && _unref(v$).service_id.$dirty }]),
            required: "",
            options: services.value,
            "option-value": "id",
            "option-label": "name",
            placeholder: "Select Service",
            onBlur: _unref(v$).service_id.$touch
          }, null, 8, ["modelValue", "options", "class", "onBlur"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).service_id.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[21] || (_cache[21] = _createElementVNode("label", { for: "service_type" }, "Service Type", -1)),
          _createVNode(_component_Dropdown, {
            id: "service_type",
            modelValue: newService.treatment_service_type_id,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newService.treatment_service_type_id) = $event)),
            class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).treatment_service_type_id.$invalid && _unref(v$).treatment_service_type_id.$dirty }]),
            required: "",
            options: serviceTypes.value,
            "option-value": "id",
            "option-label": "title",
            placeholder: "Select Service Type",
            onBlur: _unref(v$).treatment_service_type_id.$touch
          }, null, 8, ["modelValue", "options", "class", "onBlur"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).treatment_service_type_id.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ])
      ], 2)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        id: "cancel_service_btn",
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        id: "save_service_btn",
        type: "primary",
        text: "Add Service",
        onClick: save
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})